// src/pages/dashboard/talent/PlatformFeedback.js

import React, {
  useState
} from 'react';

import Swal from 'sweetalert2';

import {
  Star
} from 'lucide-react';

import {
  createPlatformFeedbackApi
} from '../../../services/api';

import './Feedback.css';

const PlatformFeedback = () => {

  const [
    rating,
    setRating
  ] = useState(0);

  const [
    review,
    setReview
  ] = useState('');

  const [
    loading,
    setLoading
  ] = useState(false);

  const handleSubmit =
  async (e) => {

    e.preventDefault();

    if (!rating) {
      return Swal.fire({
        icon: 'warning',
        title: 'Please give rating'
      });
    }

    if (review.length > 170) {
      return Swal.fire({
        icon: 'warning',
        title: 'Review cannot exceed 170 characters'
      });
    }

    try {

      setLoading(true);

      await createPlatformFeedbackApi({

        rating,
        review

      });

      Swal.fire({

        icon: 'success',

        title: 'Feedback Submitted',

        timer: 2000,

        showConfirmButton: false

      });

      setRating(0);

      setReview('');

    } catch (err) {

      Swal.fire({

        icon: 'error',

        title:
        err.response?.data?.message
        || 'Submission Failed'

      });

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="bma-feedback-page">

      <div className="bma-feedback-card">

        <div className="bma-feedback-header">

          <h2 className="bma-feedback-title">
            Platform Feedback
          </h2>

          <p className="bma-feedback-subtitle">
            Share your experience
          </p>

        </div>

        <form onSubmit={handleSubmit}>

          {/* RATING */}

          <div className="bma-feedback-group">

            <label>
               Rating
            </label>

            <div className="bma-feedback-stars">

              {
                [1,2,3,4,5].map((star) => (

                  <Star
                    key={star}
                    size={30}
                    className={
                      star <= rating
                      ? 'bma-star active'
                      : 'bma-star'
                    }
                    onClick={() =>
                      setRating(star)
                    }
                  />

                ))
              }

            </div>

          </div>


          {/* REVIEW */}

          <div className="bma-feedback-group">

            <label>
              Your Review
            </label>

           <textarea
  rows="5"
  maxLength={170}
  placeholder="Write your feedback..."
  value={review}
  onChange={(e) =>
    setReview(e.target.value)
  }
  className="bma-feedback-textarea"
/>

<div className="bma-character-count">
  {review.length}/170
</div>

          </div>


          {/* BUTTON */}

          <button
            type="submit"
            className="bma-feedback-btn"
            disabled={loading}
          >

            {
              loading
              ? 'Submitting...'
              : 'Submit Feedback'
            }

          </button>

        </form>

      </div>

    </div>

  );

};

export default PlatformFeedback;